import { UserManager, Log, WebStorageStateStore } from "oidc-client";
import sharedStore from "../../components/Stores/SharedStore";
import { navigateToSurvey } from "../../Routing/Navigation";
import { getCookie, setFreshCookie, deleteCookie } from "./AuthHelper";

export default class AuthService {
    UserManager;
    accessToken;
    authSettings;
    service;
    constructor(servicePath) {
        const auth_settings = {
            authority: sharedStore.identityConfig.stsAuthority,
            client_id: sharedStore.identityConfig.clientId,
            client_secret: atob(sharedStore.identityConfig.clientSecret),
            redirect_uri: `${sharedStore.identityConfig.clientRoot}signin-oidc-callback/`,
            silent_redirect_uri: `${sharedStore.identityConfig.clientRoot}silentrenew/`,
            post_logout_redirect_uri: `${sharedStore.identityConfig.clientRoot}`,
            response_type: 'code',
            scope: sharedStore.identityConfig.clientScope
        };

        this.authSettings = auth_settings;

        this.UserManager = new UserManager({
            ...this.authSettings,
            userStore: new WebStorageStateStore({ store: localStorage })
        });

        // Logger
        Log.logger = console;
        Log.level = Log.DEBUG;

        this.UserManager.events.addUserLoaded(user => {
            setFreshCookie('access_token', user.access_token, 3);
            setFreshCookie('expires_at', user.expires_at, 3);
        });

        this.UserManager.events.addSilentRenewError(e => {
            console.log("silent renew error", e.message);
        });

        this.UserManager.events.addAccessTokenExpired(() => {
            console.log("token expired");
            this.signinSilent();
        });
    }

  

    

    signinRedirectCallback = () => {
        this.UserManager.signinRedirectCallback().then(() => {
            navigateToSurvey();
        }).catch(err => {
            console.log(this.authSettings.client_id)
            console.log(err);
        });
    };


    getUser = async () => {
        const user = await this.UserManager.getUser();

        if (!user) {
            return await this.UserManager.signinRedirect();
        }
        return user;
    };

    signinRedirect = () => {
        localStorage.setItem("redirectUri", window.location.pathname);
        this.UserManager.signinRedirect({});
    };

    isAuthenticated = () => {
        const expires_at = getCookie('expires_at');
        let result = false;
        if (expires_at) {
            const currentTime = Math.round(Date.now() / 1000);
            if (currentTime > expires_at) {
                this.signinSilent();
            }
            const access_token = getCookie('access_token');
            result = !!access_token;

        }
        return result;

    };

    signinSilent = () => {
        this.UserManager.signinSilent()
            .then(user => {
                setFreshCookie('access_token', user.access_token, 3)
                setFreshCookie('expires_at', user.expires_at, 3);
           

            })
            .catch(err => {
                console.log(err);
                this.signinRedirect();
            });
    };
    signinSilentCallback = () => {
        this.UserManager.signinSilentCallback();
    };

    createSigninRequest = () => {
        return this.UserManager.createSigninRequest();
    };

    logout = () => {
        this.UserManager.signoutRedirect({
        });
        deleteCookie("access_token_pabs");
        deleteCookie("access_token_ibs");
        deleteCookie("access_token");
        deleteCookie("IbsUserId");
        this.UserManager.clearStaleState();
        this.authSettings = '';
        this.service = '';
        localStorage.clear();
        sessionStorage.clear();
    };

    signoutRedirectCallback = () => {
        this.UserManager.signoutRedirectCallback().then(() => {
            deleteCookie("access_token_pabs");
            deleteCookie("access_token_ibs");
            deleteCookie("access_token");
            deleteCookie("IbsUserId");
            this.authSettings = '';
            this.service = '';
            localStorage.clear();
            sessionStorage.clear();
            window.location.replace(process.env.REACT_APP_PUBLIC_URL);
        });
        this.UserManager.clearStaleState();
    };
}
